import { getOrganizationMembers } from "../../api/organizations/organizationsApi";
import { getMyDetails } from "../../api/users/usersApi";

export const loadCurrentUserDetails = async (org_id: string, token: string) => {
    if (token) {
        const tempMembers = await getOrganizationMembers(token, org_id)
        const user = await getMyDetails(token);

        if (user.is_superuser) {
            return true;
        }

        for (const member of tempMembers.results) {
            if (member.email === user.email) {

                return member.role === "admin";
            }
        }
        return false;
    }

    return false;
}